import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";

import { UserContext } from "../context/UserContext";

export const RequirePro = () => {
  const { user, userData, loading } = React.useContext(UserContext);
  let location = useLocation();

  if (loading === false && !user) {
    return <Navigate to="/" state={{ from: location }} />;
  } else if (loading === false && userData) {
    if (userData?.userType?.category === "user") {
      return <Navigate to="/" state={{ from: location }} />;
    }

    return <Outlet />;
  } else return <div>Loading...</div>;
};
